
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soeg",
      function () {
        return require("private-next-pages/soeg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soeg"])
      });
    }
  